import { create } from "zustand";

interface IUserInfo {
  id?: string;
  email?: string;
  telegram?: string;
  telegramUsername?: string;
  icon?: string;
  wallet?: number;
  referralDepositBonusRate: number;
  referralInstallBonusRate: number;
}

interface ModalState {
  isOpen: boolean;
  isReferralModalOpen: boolean;
  isUserStatsModalOpen: boolean;
  isUserWalletModalOpen: boolean;
  mode: "login" | "signup" | "verification" | "forgotPassword" | "" | "passwordRecovery";
  userInfo: IUserInfo;
  changeUserInfo: (newInfo: Partial<IUserInfo>) => void;
  openModal: (mode: "login" | "signup" | "forgotPassword" | "" | "passwordRecovery") => void;
  openReferralModal: () => void;
  openUserStatsModal: () => void;
  openUserWalletModal: () => void;
  closeModal: () => void;
}

export const defaultUserInfo: IUserInfo = {
  id: "",
  email: "",
  telegram: "",
  telegramUsername: "",
  icon: "",
  wallet: 0,
  referralDepositBonusRate: 5,
  referralInstallBonusRate: 13,
};

const useModalStore = create<ModalState>((set) => ({
  isOpen: false,
  isReferralModalOpen: false,
  isUserStatsModalOpen: false,
  isUserWalletModalOpen: false,
  mode: "",
  userInfo: { ...defaultUserInfo },
  changeUserInfo: (newInfo) =>
    set((state) => {
      const updatedUserInfo = { ...state.userInfo, ...newInfo };
      return { userInfo: updatedUserInfo };
    }),
  openModal: (mode: "login" | "signup" | "verification" | "forgotPassword" | "passwordRecovery" | "") =>
    set({ isOpen: true, mode }),
  openReferralModal: () => set({ isReferralModalOpen: true }),
  openUserStatsModal: () => set({ isUserStatsModalOpen: true }),
  openUserWalletModal: () => set({ isUserWalletModalOpen: true }),
  closeModal: () =>
    set({
      isOpen: false,
      isReferralModalOpen: false,
      isUserStatsModalOpen: false,
      isUserWalletModalOpen: false,
      mode: "",
    }),
}));

export default useModalStore;
